module.exports = __webpack_public_path__ + "static/media/CS118.8647db5a.PNG";